document.addEventListener("DOMContentLoaded", function () {
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");

    const value = (Number(cents || 0) / 100).toFixed(2);

    if (!format) return "£" + value;

    return format
      .replace(/{{\s*amount\s*}}/g, value)
      .replace(/{{\s*amount_no_decimals\s*}}/g, Math.round(value));
  }

  document.addEventListener("click", function (e) {
    const toggle = e.target.closest("[data-menu-toggle]");
    if (!toggle) return;

    const menu = document.querySelector("[data-mobile-menu]");
    if (menu) menu.hidden = !menu.hidden;
  });

  document.addEventListener("click", function (e) {
    const reviewLink = e.target.closest('a[href="#reviews"]');

    if (!reviewLink) return;

    e.preventDefault();

    const reviews = document.querySelector("#reviews");
    if (!reviews) return;

    const stickyHeaderOffset = 100;

    const reviewsTop =
      reviews.getBoundingClientRect().top +
      window.pageYOffset -
      stickyHeaderOffset;

    window.scrollTo({
      top: reviewsTop,
      behavior: "smooth",
    });
  });

  document
    .querySelectorAll("[data-product-section]")
    .forEach(function (section) {
      const productEl = section.querySelector("[data-product-json]");
      if (!productEl) return;

      let product;

      try {
        product = JSON.parse(productEl.textContent);
      } catch (error) {
        console.error("Product JSON error:", error);
        return;
      }

      const moneyFormatEl = section.querySelector("[data-money-format]");
      let moneyFormat = "£{{ amount }}";

      if (moneyFormatEl) {
        try {
          moneyFormat = JSON.parse(
            moneyFormatEl.textContent || '"£{{ amount }}"'
          );
        } catch (error) {
          moneyFormat = "£{{ amount }}";
        }
      }

      const variantInput = section.querySelector("[data-variant-id]");
      const qtyInput = section.querySelector("[data-quantity-input]");
      const priceEl = section.querySelector("[data-product-price]");
      const compareEl = section.querySelector("[data-product-compare]");
      const addBtn = section.querySelector("[data-add-button]");
      const addText = section.querySelector("[data-add-text]");
      const msg = section.querySelector("[data-form-message]");
      const form = section.querySelector("[data-product-form]");
      const stickyAtc = section.querySelector("[data-sticky-atc]");

      if (stickyAtc && stickyAtc.parentElement !== document.body) {
        document.body.appendChild(stickyAtc);
      }

      const stickyRoot = stickyAtc || section;

      const stickyVariantText = stickyRoot.querySelector(
        "[data-sticky-variant-text]"
      );
      const stickyPrice = stickyRoot.querySelector("[data-sticky-price]");
      const stickyVariantImage = stickyRoot.querySelector(
        "[data-sticky-variant-image]"
      );
      const stickyAddBtn = stickyRoot.querySelector("[data-sticky-add-button]");
      const stickyQtyInput = stickyRoot.querySelector("[data-sticky-qty-input]");
      const stickyQtyMinus = stickyRoot.querySelector("[data-sticky-qty-minus]");
      const stickyQtyPlus = stickyRoot.querySelector("[data-sticky-qty-plus]");

      function selectedOptions() {
        return product.options.map(function (_, index) {
          const checked = section.querySelector(
            '[data-option-position="' +
              (index + 1) +
              '"] [data-option-input]:checked'
          );

          return checked ? checked.value : null;
        });
      }

      function findVariant(options) {
        return product.variants.find(function (variant) {
          return variant.options.every(function (optionValue, index) {
            return optionValue === options[index];
          });
        });
      }

      function packQuantityFromVariant(variant) {
        if (!variant) return 1;

        const title = variant.options.join(" ").toLowerCase();
        const match = title.match(/(\d+)\s*[- ]?pack/);

        return match ? Number(match[1]) : 1;
      }

      function smoothScrollTo(targetY, duration) {
        const startY = window.pageYOffset;
        const distance = targetY - startY;
        const startTime = performance.now();

        function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }

        function animation(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = easeInOutCubic(progress);

          window.scrollTo(0, startY + distance * easedProgress);

          if (progress < 1) {
            requestAnimationFrame(animation);
          }
        }

        requestAnimationFrame(animation);
      }

      function goToVariantImageInGallery(variant) {
        if (!variant || !variant.featured_image || !variant.featured_image.src)
          return;

        const variantImageSrc = variant.featured_image.src.split("?")[0];
        const mainGallery = section.querySelector("[data-hero-gallery]");
        const thumbsWrapper = section.querySelector("[data-hero-thumbs]");
        const thumbs = section.querySelectorAll("[data-gallery-thumb]");

        if (!thumbs.length) return;

        let matchingThumb = null;

        thumbs.forEach(function (thumb) {
          const thumbImage = thumb.getAttribute("data-gallery-image");
          if (!thumbImage) return;

          const cleanThumbImage = thumbImage.split("?")[0];

          if (
            cleanThumbImage === variantImageSrc ||
            cleanThumbImage.includes(variantImageSrc) ||
            variantImageSrc.includes(cleanThumbImage)
          ) {
            matchingThumb = thumb;
          }
        });

        if (!matchingThumb) return;

        matchingThumb.click();

        if (mainGallery) {
          const stickyHeaderOffset = 70;

          const galleryTop =
            mainGallery.getBoundingClientRect().top +
            window.pageYOffset -
            stickyHeaderOffset;

          smoothScrollTo(galleryTop, 1150);
        }

        if (thumbsWrapper) {
          const wrapperRect = thumbsWrapper.getBoundingClientRect();
          const thumbRect = matchingThumb.getBoundingClientRect();

          const newScrollLeft =
            thumbsWrapper.scrollLeft +
            thumbRect.left -
            wrapperRect.left -
            wrapperRect.width / 2 +
            thumbRect.width / 2;

          thumbsWrapper.scrollTo({
            left: newScrollLeft,
            behavior: "smooth",
          });
        }
      }

      function updateChoicePrices() {
        section
          .querySelectorAll("[data-option-position]")
          .forEach(function (fieldset) {
            const optionName = (
              fieldset.getAttribute("data-option-name") || ""
            ).toLowerCase();
            const isPackOption = optionName.includes("pack");

            if (!isPackOption) return;

            const packPosition =
              Number(fieldset.getAttribute("data-option-position")) - 1;

            fieldset
              .querySelectorAll("[data-option-label]")
              .forEach(function (label) {
                const priceTarget = label.querySelector("[data-choice-price]");
                const eachTarget = label.querySelector(
                  "[data-pack-each-price]"
                );
                const input = label.querySelector("[data-option-input]");

                if (!priceTarget || !input) return;

                const options = selectedOptions();
                options[packPosition] = input.value;

                const possible = findVariant(options);

                if (!possible) {
                  priceTarget.innerHTML = "";
                  if (eachTarget) eachTarget.textContent = "";
                  return;
                }

                const qty = packQuantityFromVariant(possible);
                const totalPrice = formatMoney(possible.price, moneyFormat);

                const onePackOptions = options.slice();
                onePackOptions[packPosition] = "1-Pack";

                let onePackVariant = findVariant(onePackOptions);

                if (!onePackVariant) {
                  onePackOptions[packPosition] = "1 Pack";
                  onePackVariant = findVariant(onePackOptions);
                }

                const onePackPrice = onePackVariant
                  ? onePackVariant.price
                  : null;

                if (eachTarget) {
                  eachTarget.textContent =
                    qty > 1
                      ? formatMoney(
                          Math.round(possible.price / qty),
                          moneyFormat
                        ) + " each"
                      : formatMoney(possible.price, moneyFormat) + " each";
                }

                let saveHtml = "";

                if (onePackPrice && qty > 1) {
                  const normalPrice = onePackPrice * qty;
                  const saving = normalPrice - possible.price;

                  if (saving > 0) {
                    saveHtml =
                      "<em>Save " + formatMoney(saving, moneyFormat) + "</em>";
                  }
                }

                priceTarget.innerHTML =
                  "<small>Total</small><b>" + totalPrice + "</b>" + saveHtml;
              });
          });
      }

      function updateSelectedClasses() {
        section
          .querySelectorAll("[data-option-input]")
          .forEach(function (input) {
            const label = input.closest(".df-choice-card, .df-swatch");
            if (!label) return;

            label.classList.toggle("is-selected", input.checked);
          });
      }

      function getSelectedVariantText(variant) {
        if (!variant || !variant.options || variant.title === "Default Title")
          return "";

        return variant.options.filter(Boolean).join(" / ");
      }

      function syncStickyQuantity(value) {
        const qty = Math.max(1, Number(value || 1));

        if (stickyQtyInput) stickyQtyInput.value = qty;
        if (qtyInput) qtyInput.value = qty;
      }

      function updateStickyAtc(variant) {
        if (!variant) {
          if (stickyVariantImage && product.featured_image) {
            stickyVariantImage.removeAttribute("srcset");
            stickyVariantImage.removeAttribute("sizes");
            stickyVariantImage.src = product.featured_image;
            stickyVariantImage.alt = product.title;
          }

          if (stickyAddBtn) {
            stickyAddBtn.disabled = true;
            stickyAddBtn.textContent = "Unavailable";
          }

          if (stickyVariantText) stickyVariantText.textContent = "";
          return;
        }

        if (stickyVariantText) {
          stickyVariantText.textContent = getSelectedVariantText(variant);
        }

        if (stickyPrice) {
          stickyPrice.textContent = formatMoney(variant.price, moneyFormat);
        }

        if (stickyAddBtn) {
          stickyAddBtn.disabled = !variant.available;
          stickyAddBtn.textContent = variant.available
            ? "Add to Cart"
            : "Sold Out";
        }
      }

      function initStickyAtc() {
        if (!stickyAtc || !form) return;

        syncStickyQuantity(1);

        if (stickyQtyMinus) {
          stickyQtyMinus.addEventListener("click", function () {
            const currentQty = Number(
              stickyQtyInput ? stickyQtyInput.value : 1
            );
            syncStickyQuantity(currentQty - 1);
          });
        }

        if (stickyQtyPlus) {
          stickyQtyPlus.addEventListener("click", function () {
            const currentQty = Number(
              stickyQtyInput ? stickyQtyInput.value : 1
            );
            syncStickyQuantity(currentQty + 1);
          });
        }

        if (stickyQtyInput) {
          stickyQtyInput.addEventListener("input", function () {
            syncStickyQuantity(stickyQtyInput.value);
          });

          stickyQtyInput.addEventListener("blur", function () {
            syncStickyQuantity(stickyQtyInput.value);
          });
        }

        if (stickyAddBtn) {
          stickyAddBtn.addEventListener("click", function () {
            if (stickyAddBtn.disabled) return;

            syncStickyQuantity(stickyQtyInput ? stickyQtyInput.value : 1);

            if (addBtn) {
              addBtn.click();
            } else {
              form.requestSubmit();
            }
          });
        }

        function toggleStickyAtc() {
          const buyBox = section.querySelector("#df-buy-box");
          if (!buyBox) return;

          const buyBoxBottom = buyBox.getBoundingClientRect().bottom;
          const shouldShow = buyBoxBottom < 0;

          stickyAtc.classList.toggle("is-visible", shouldShow);
          document.body.classList.toggle("df-sticky-atc-visible", shouldShow);
        }

        window.addEventListener("scroll", toggleStickyAtc, { passive: true });
        window.addEventListener("resize", toggleStickyAtc);
        toggleStickyAtc();
      }

      function refresh(shouldGoToVariantImage) {
        const variant = findVariant(selectedOptions());

        updateSelectedClasses();

        if (!variant) {
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = "Unavailable";
          updateStickyAtc(null);
          return;
        }

        if (variantInput) variantInput.value = variant.id;

        syncStickyQuantity(stickyQtyInput ? stickyQtyInput.value : 1);

        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price, moneyFormat);
        }

        if (compareEl) {
          compareEl.textContent =
            variant.compare_at_price && variant.compare_at_price > variant.price
              ? formatMoney(variant.compare_at_price, moneyFormat)
              : "";
        }

        if (addBtn) addBtn.disabled = !variant.available;

        if (addText) {
          addText.textContent = variant.available
            ? "Get My DryFloor™ Mat"
            : "Sold Out";
        }

        updateStickyAtc(variant);

        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url);

        if (shouldGoToVariantImage) {
          goToVariantImageInGallery(variant);
        }

        updateChoicePrices();
      }

      function initHeroProductGallery() {
        const mainImage =
          section.querySelector("[data-hero-main-image]") ||
          section.querySelector(".df-hero-img");

        const mainGallery = section.querySelector("[data-hero-gallery]");
        const thumbsWrapper = section.querySelector("[data-hero-thumbs]");
        const thumbs = Array.from(
          section.querySelectorAll("[data-gallery-thumb]")
        );

        if (!mainImage || !thumbsWrapper || !thumbs.length) {
          console.warn("DryFloor gallery missing:", {
            mainImage: !!mainImage,
            thumbsWrapper: !!thumbsWrapper,
            thumbs: thumbs.length,
          });
          return;
        }

        let currentIndex = thumbs.findIndex(function (thumb) {
          return thumb.classList.contains("is-active");
        });

        if (currentIndex < 0) currentIndex = 0;

        function changeMainImage(thumb) {
          const newImage = thumb.getAttribute("data-gallery-image");
          const newAlt = thumb.getAttribute("data-gallery-alt") || "";

          if (!newImage) return;

          thumbs.forEach(function (item) {
            item.classList.remove("is-active");
          });

          thumb.classList.add("is-active");

          currentIndex = thumbs.indexOf(thumb);

          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.removeAttribute("data-src");
          mainImage.removeAttribute("data-srcset");

          mainImage.src = newImage;
          mainImage.alt = newAlt;

          scrollActiveThumbIntoView();
        }

        function scrollActiveThumbIntoView() {
          const activeThumb = thumbs[currentIndex];
          if (!activeThumb || !thumbsWrapper) return;

          const wrapperRect = thumbsWrapper.getBoundingClientRect();
          const thumbRect = activeThumb.getBoundingClientRect();

          const newScrollLeft =
            thumbsWrapper.scrollLeft +
            thumbRect.left -
            wrapperRect.left -
            wrapperRect.width / 2 +
            thumbRect.width / 2;

          thumbsWrapper.scrollTo({
            left: newScrollLeft,
            behavior: "smooth",
          });
        }

        function goToImage(index) {
          if (index < 0) index = thumbs.length - 1;
          if (index >= thumbs.length) index = 0;

          changeMainImage(thumbs[index]);
        }

        thumbs.forEach(function (thumb, index) {
          if (
            index === 0 &&
            !section.querySelector("[data-gallery-thumb].is-active")
          ) {
            thumb.classList.add("is-active");
            currentIndex = 0;
          }
        });

        section.addEventListener("click", function (event) {
          const thumb = event.target.closest("[data-gallery-thumb]");
          if (!thumb || !section.contains(thumb)) return;

          event.preventDefault();
          changeMainImage(thumb);
        });

        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;

        thumbsWrapper.addEventListener("mousedown", function (e) {
          isDown = true;
          thumbsWrapper.classList.add("is-dragging");
          startX = e.pageX - thumbsWrapper.offsetLeft;
          scrollLeft = thumbsWrapper.scrollLeft;
        });

        thumbsWrapper.addEventListener("mouseleave", function () {
          isDown = false;
          thumbsWrapper.classList.remove("is-dragging");
        });

        thumbsWrapper.addEventListener("mouseup", function () {
          isDown = false;
          thumbsWrapper.classList.remove("is-dragging");
        });

        thumbsWrapper.addEventListener("mousemove", function (e) {
          if (!isDown) return;

          e.preventDefault();

          const x = e.pageX - thumbsWrapper.offsetLeft;
          const walk = (x - startX) * 1.4;

          thumbsWrapper.scrollLeft = scrollLeft - walk;
        });

        let touchStartX = 0;
        let touchStartY = 0;
        let touchEndX = 0;
        let touchEndY = 0;

        const swipeTarget = mainGallery || mainImage;

        swipeTarget.addEventListener(
          "touchstart",
          function (e) {
            if (!e.touches || !e.touches.length) return;

            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          "touchend",
          function (e) {
            if (!e.changedTouches || !e.changedTouches.length) return;

            touchEndX = e.changedTouches[0].clientX;
            touchEndY = e.changedTouches[0].clientY;

            const diffX = touchStartX - touchEndX;
            const diffY = touchStartY - touchEndY;

            const isHorizontalSwipe = Math.abs(diffX) > Math.abs(diffY);
            const isRealSwipe = Math.abs(diffX) > 45;

            if (!isHorizontalSwipe || !isRealSwipe) return;

            if (diffX > 0) {
              goToImage(currentIndex + 1);
            } else {
              goToImage(currentIndex - 1);
            }
          },
          { passive: true }
        );
      }

      section.addEventListener("change", function (e) {
        if (!e.target.matches("[data-option-input]")) return;

        const fieldset = e.target.closest("[data-option-position]");
        const optionName = fieldset
          ? (fieldset.getAttribute("data-option-name") || "").toLowerCase()
          : "";

        const isColorOption =
          optionName.includes("color") || optionName.includes("colour");

        if (isColorOption) {
          refresh(true);
        } else {
          refresh(false);
        }
      });

      if (form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();

          if (msg) msg.textContent = "";
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = "Adding...";

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
            },
            body: new FormData(form),
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (err) {
                  throw err;
                });
              }

              return res.json();
            })
            .then(function () {
              window.location.href = "/cart";
            })
            .catch(function (err) {
              if (msg) {
                msg.textContent =
                  err && err.description
                    ? err.description
                    : "Sorry, this item could not be added.";
              }

              if (addBtn) addBtn.disabled = false;
              if (addText) addText.textContent = "Get My DryFloor™ Mat";
            });
        });
      }

      initHeroProductGallery();
      initStickyAtc();
      refresh(false);
    });

  function initBeforeAfterSliders() {
    document.querySelectorAll("[data-before-after]").forEach(function (slider) {
      const range = slider.querySelector("[data-before-after-range]");
      const after = slider.querySelector("[data-before-after-after]");
      const divider = slider.querySelector("[data-before-after-divider]");
      const imageWrap = slider.querySelector(".df-before-after__image-wrap");
      const afterImage = slider.querySelector(".df-before-after__image--after");

      if (!range || !after || !divider || !imageWrap) return;

      function syncAfterImageWidth() {
        const wrapWidth = imageWrap.getBoundingClientRect().width;

        if (wrapWidth && afterImage) {
          slider.style.setProperty("--df-ba-width", wrapWidth + "px");
        }
      }

      function updateSlider(value) {
        const percent = Math.max(0, Math.min(100, Number(value || 50)));

        syncAfterImageWidth();

        after.style.width = percent + "%";
        divider.style.left = percent + "%";
      }

      range.addEventListener("input", function () {
        updateSlider(range.value);
      });

      range.addEventListener("mousedown", function () {
        slider.classList.add("is-dragging");
      });

      range.addEventListener("mouseup", function () {
        slider.classList.remove("is-dragging");
      });

      range.addEventListener("mouseleave", function () {
        slider.classList.remove("is-dragging");
      });

      range.addEventListener("touchstart", function () {
        slider.classList.add("is-dragging");
      });

      range.addEventListener("touchend", function () {
        slider.classList.remove("is-dragging");
      });

      window.addEventListener("resize", function () {
        updateSlider(range.value);
      });

      if (window.ResizeObserver) {
        const observer = new ResizeObserver(function () {
          updateSlider(range.value);
        });

        observer.observe(imageWrap);
      }

      updateSlider(range.value);
    });
  }

  function initSizeGuidePopup() {
    const modal = document.querySelector("[data-size-guide-modal]");
    const openButtons = document.querySelectorAll("[data-size-guide-open]");
    const closeButtons = document.querySelectorAll("[data-size-guide-close]");

    if (!modal || !openButtons.length) return;

    function openModal() {
      modal.hidden = false;
      document.body.classList.add("df-modal-open");
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove("df-modal-open");
    }

    openButtons.forEach(function (button) {
      button.addEventListener("click", openModal);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) {
        closeModal();
      }
    });

    function initFaqLoadMore() {
      const button = document.querySelector("[data-faq-load-more]");
      const hiddenFaqs = document.querySelectorAll(".dfx-faq-extra[hidden]");

      if (!button || !hiddenFaqs.length) return;

      button.addEventListener("click", function () {
        hiddenFaqs.forEach(function (faq) {
          faq.hidden = false;
        });

        button.classList.add("is-hidden");
      });
    }

    initFaqLoadMore();
  }

  initSizeGuidePopup();
  initBeforeAfterSliders();
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("[data-desktop-thumbs-wrap]")
    .forEach(function (wrap) {
      const thumbs = wrap.querySelector("[data-hero-thumbs]");
      const up = wrap.querySelector("[data-thumbs-up]");
      const down = wrap.querySelector("[data-thumbs-down]");

      if (!thumbs || !up || !down) return;

      function scrollThumbs(direction) {
        const firstThumb = thumbs.querySelector("[data-gallery-thumb]");
        const thumbHeight = firstThumb ? firstThumb.offsetHeight : 78;
        const gap = 8;
        const scrollAmount = (thumbHeight + gap) * 3;

        thumbs.scrollBy({
          top: direction * scrollAmount,
          behavior: "smooth",
        });
      }

      up.addEventListener("click", function () {
        scrollThumbs(-1);
      });

      down.addEventListener("click", function () {
        scrollThumbs(1);
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const desktopQuery = window.matchMedia("(min-width: 990px)");

  function syncThumbsHeightToGallery() {
    const gallery = document.querySelector("[data-hero-gallery]");
    const thumbs = document.querySelector("[data-hero-thumbs]");

    if (!gallery || !thumbs) return;

    if (!desktopQuery.matches) {
      thumbs.style.height = "";
      thumbs.style.maxHeight = "";
      return;
    }

    const galleryHeight = gallery.getBoundingClientRect().height;

    if (galleryHeight > 0) {
      thumbs.style.height = galleryHeight + "px";
      thumbs.style.maxHeight = galleryHeight + "px";
    }
  }

  syncThumbsHeightToGallery();

  window.addEventListener("resize", syncThumbsHeightToGallery);

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener("change", syncThumbsHeightToGallery);
  }

  const galleryImage = document.querySelector("[data-hero-main-image]");

  if (galleryImage) {
    galleryImage.addEventListener("load", syncThumbsHeightToGallery);
  }

  if (window.ResizeObserver) {
    const gallery = document.querySelector("[data-hero-gallery]");

    if (gallery) {
      const observer = new ResizeObserver(syncThumbsHeightToGallery);
      observer.observe(gallery);
    }
  }
});